<template>
  <div id="RegisterCheck" class="register-check-page" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <div
      class="btn Pointer btn-outline-info d-none"
      @click="openModal"
      data-toggle="modal"
      data-target="#Modal-RegisterCheck"
    >
      <i class="fas fa-list ml-2"></i>
    </div>

    <div
      class="modal fade register-check-modal"
      id="Modal-RegisterCheck"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="Modal-RegisterCheckLabel"
      aria-hidden="true"
      dir="rtl"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header register-check-modal__header">
            <h6 class="modal-title" id="Modal-RegisterCheckLabel">
              <i class="fas fa-search" aria-hidden="true"></i>
              رهگیری ثبت نام
            </h6>
          </div>
          <div class="modal-body register-check-modal__body">
            <form class="register-check-search-form" @submit.prevent="getData()">
              <label class="register-check-field">
                <span class="register-check-label">کد ملی</span>
                <input
                  type="number"
                  maxlength="10"
                  @keypress="$ValidNumber($event, 10)"
                  class="form-control register-check-input"
                  dir="ltr"
                  v-model="CodeMeli"
                  placeholder="کد ملی"
                />
              </label>
              <label v-if="NotCode" class="register-check-field">
                <span class="register-check-label">کد رهگیری</span>
                <input
                  type="number"
                  maxlength="20"
                  @keypress="$ValidNumber($event, 20)"
                  class="form-control register-check-input"
                  dir="ltr"
                  v-model="CodeRahgiri"
                  placeholder="کد رهگیری"
                />
              </label>
              <div class="register-check-search-actions">
                <button type="submit" class="sv-btn sv-btn--primary">
                  <i class="fas fa-search" aria-hidden="true"></i>
                  جستجو
                </button>
                <button
                  type="button"
                  class="sv-btn sv-btn--ghost"
                  data-dismiss="modal"
                  @click="GoToLogin"
                >
                  انصراف
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <panel
      Title="بررسی وضعیت درخواست عضویت"
      Des="با کد ملی می‌توانید وضعیت درخواست عضویت خود را پیگیری کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
      @back="GoToLogin"
    ></panel>

    <net-pa-tab
      class="no-print"
      :Tabs="CheckTabs"
      :Active="activeTabId"
      @change="onTabChange"
    >
      <button
        type="button"
        class="register-check-search-btn"
        @click="search()"
      >
        <i class="fas fa-search" aria-hidden="true"></i>
        جستجو
      </button>
    </net-pa-tab>

    <net-pa-card class="register-check-card no-print" :Compact="true">
      <template slot="content">
        <div
          class="tab-content text-right register-check-tab-content"
          id="nav-tabContent"
        >
          <div
            class="tab-pane fade"
            :class="{ 'show active': currentIndex === 0 }"
            id="nav-aut"
            role="tabpanel"
            aria-labelledby="nav-aut-tab"
          >
            <div v-if="GatData" class="register-check-status-card register-check-status-card--success">
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-user-shield"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>احراز هویت با موفقیت انجام شده</h6>
                <p>
                  اطلاعات هویتی شما (توسط سامانه ثبت احوال) مورد تایید می‌باشد
                </p>
              </div>
            </div>
            <div v-else class="register-check-empty">
              <i class="fas fa-id-card" aria-hidden="true"></i>
              <p>برای مشاهده وضعیت احراز هویت، کد ملی خود را جستجو کنید.</p>
              <button
                type="button"
                class="sv-btn sv-btn--primary"
                @click="search()"
              >
                جستجوی درخواست
              </button>
            </div>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': currentIndex === 1 }"
            id="nav-pay"
            role="tabpanel"
            aria-labelledby="nav-pay-tab"
          >
            <div v-if="!GatData" class="register-check-empty">
              <i class="fas fa-receipt" aria-hidden="true"></i>
              <p>پس از جستجوی درخواست، امکان پرداخت در این بخش نمایش داده می‌شود.</p>
              <button
                type="button"
                class="sv-btn sv-btn--primary"
                @click="search()"
              >
                جستجوی درخواست
              </button>
            </div>
            <div v-else class="register-check-pay">
              <div class="register-check-note">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
                <span>صدور وجه از طریق بانک امکان‌پذیر می‌باشد</span>
              </div>

              <div
                v-if="$session.get('CustCode') == '932'"
                class="register-check-methods"
                role="radiogroup"
                aria-label="روش پرداخت"
              >
                <button
                  type="button"
                  class="register-check-method"
                  :class="{ 'is-active': Ravesh == 1 }"
                  @click="Ravesh = 1"
                >
                  پرداخت آنلاین
                </button>
                <button
                  type="button"
                  class="register-check-method"
                  :class="{ 'is-active': Ravesh == 2 }"
                  @click="Ravesh = 2"
                >
                  آپلود فیش بانکی
                </button>
              </div>

              <div v-if="Ravesh == 1">
                <div
                  v-if="GatData.codeRahgiri == 'BnpCo'"
                  class="register-check-pay-panel"
                  id="div1"
                >
                  <section class="register-check-pay-step">
                    <h6 class="register-check-pay-step__title">
                      <span class="register-check-pay-step__num">۱</span>
                      مبلغ حق عضویت
                    </h6>
                    <label class="register-check-field">
                      <span class="register-check-label">مبلغ واریزی (ریال)</span>
                      <input
                        class="form-control register-check-input 3ragham"
                        id="Mab"
                        :disabled="FixVariz"
                        v-model="Mablagh"
                        dir="ltr"
                        type="number"
                        placeholder="مبلغ واریزی را وارد کنید"
                      />
                      <span
                        v-if="Number(Mablagh) > 0"
                        class="register-check-amount-words"
                      >
                        {{ $Comma3ragham(Mablagh) }} ریال
                      </span>
                      <span v-else class="register-check-amount-hint">
                        حداقل مبلغ قابل پرداخت ۱۰,۰۰۰ ریال است
                      </span>
                    </label>
                  </section>

                  <section class="register-check-pay-step register-check-gateway">
                    <h6 class="register-check-pay-step__title">
                      <span class="register-check-pay-step__num">۲</span>
                      درگاه و پرداخت
                    </h6>
                    <payment
                      @GatewayCode="Get_GatewayCode"
                      @FixVarizGhest="FixVarizGhest"
                    >
                      <template v-slot:ContentButtonPayment>
                        <button
                          id="BtnPayment"
                          class="sv-btn register-check-pay-btn"
                          :class="
                            !loading || Number(Mablagh) < 10000
                              ? 'sv-btn--ghost'
                              : 'sv-btn--primary'
                          "
                          :disabled="!loading || Number(Mablagh) < 10000"
                          @click.prevent="Payment"
                        >
                          <i class="fas fa-lock" aria-hidden="true"></i>
                          <template v-if="Number(Mablagh) > 0">
                            پرداخت {{ $Comma3ragham(Mablagh) }} ریال
                          </template>
                          <template v-else>پرداخت</template>
                        </button>
                      </template>
                    </payment>
                  </section>
                </div>
                <div v-else class="register-check-receipt">
                  <div class="register-check-receipt__badge">
                    <i class="fas fa-check-circle" aria-hidden="true"></i>
                    {{ TextVazeiat }}
                  </div>
                  <div class="register-check-receipt__rows">
                    <div class="register-check-receipt__row">
                      <span>تاریخ</span>
                      <strong>{{ GatData.tarixSanad }}</strong>
                    </div>
                    <div class="register-check-receipt__row">
                      <span>کد رهگیری</span>
                      <strong dir="ltr">{{ Rahgiri }}</strong>
                    </div>
                    <div class="register-check-receipt__row">
                      <span>پرداخت‌کننده</span>
                      <strong>
                        {{ GatData.ozvName + " " + GatData.ozvFamily }}
                      </strong>
                    </div>
                    <div class="register-check-receipt__row">
                      <span>مبلغ پرداختی</span>
                      <strong>
                        {{ $Comma3ragham(GatData.bestan) }} ریال
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="Ravesh == 2" class="register-check-upload">
                <p class="register-check-upload__lead">
                  لطفا فیش واریزی خود به مبلغ
                  <b>{{ $Comma3ragham(Mablagh) }} ریال</b>
                  را بارگذاری کنید
                </p>
                <input
                  type="file"
                  @change="changefile($event)"
                  class="d-none"
                  id="Uploader"
                  accept=".gif,.jpg,.jpeg,.png,.pdf"
                />
                <button
                  type="button"
                  class="register-check-upload__drop"
                  @click.prevent="clickUploader"
                >
                  <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                  <strong>
                    {{
                      fileinfo.name
                        ? fileinfo.name
                        : "برای بارگذاری فیش واریزی کلیک کنید"
                    }}
                  </strong>
                  <span v-if="fileinfo.size">
                    {{ (fileinfo.size / 1000000).toFixed(2) }} MB
                  </span>
                  <span v-else>فرمت مجاز: jpg، png، gif یا pdf تا ۵ مگابایت</span>
                </button>
                <button
                  v-if="fileinfo.size && fileinfo.name"
                  type="button"
                  class="sv-btn sv-btn--primary sv-btn--wide"
                  @click="UploadFishVariz"
                >
                  آپلود فیش
                </button>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': currentIndex === 2 }"
            id="nav-state"
            role="tabpanel"
            aria-labelledby="nav-state-tab"
          >
            <div v-if="!GatData" class="register-check-empty">
              <i class="fas fa-clipboard-check" aria-hidden="true"></i>
              <p>پس از جستجوی درخواست، وضعیت عضویت اینجا نمایش داده می‌شود.</p>
              <button
                type="button"
                class="sv-btn sv-btn--primary"
                @click="search()"
              >
                جستجوی درخواست
              </button>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070520"
              class="register-check-status-card register-check-status-card--success"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>درخواست عضویت شما با موفقیت تایید شده است</h6>
              </div>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070521"
              class="register-check-status-card register-check-status-card--danger"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-times-circle"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>درخواست عضویت شما تایید نشده است</h6>
                <p>علت رد درخواست: {{ GatData.desState }}</p>
              </div>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070522"
              class="register-check-status-card register-check-status-card--warning"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-edit"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>درخواست عضویت شما نیاز به اصلاح دارد</h6>
                <p>توضیحات اصلاح: {{ GatData.desState }}</p>
                <button
                  class="sv-btn sv-btn--primary no-print"
                  type="button"
                  @click="GetRigister(GatData.id)"
                >
                  اصلاح اطلاعات
                </button>
              </div>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070519"
              class="register-check-status-card register-check-status-card--info"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-hourglass-half"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>درخواست عضویت شما در حال بررسی می‌باشد</h6>
              </div>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070518"
              class="register-check-status-card register-check-status-card--info"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-credit-card"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>لطفا از مرحله دوم پرداخت حق عضویت را انجام دهید</h6>
              </div>
            </div>
            <div
              v-else-if="GatData.wwwtblcomboidgrp331 == 181070525"
              class="register-check-status-card register-check-status-card--info"
            >
              <div class="register-check-status-card__icon" aria-hidden="true">
                <i class="fas fa-hourglass-half"></i>
              </div>
              <div class="register-check-status-card__body">
                <h6>
                  درخواست عضویت شما در حال بررسی می‌باشد (توسط فیش واریزی)
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div class="register-check-footer" v-if="currentIndex != 2">
          <button
            type="button"
            class="sv-btn sv-btn--primary sv-btn--wide"
            @click="Go"
          >
            مرحله بعدی
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
          </button>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import Payment from "../CmpNetPa/Payment.vue";
import Num2persian from "num2persian";
import loading from "../Tools/NetPa/Loading.vue";

export default {
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    Payment,
    Num2persian,
    loading,
  },
  data() {
    return {
      appsettings: null,
      fileinfo: {},
      NotCode: false,
      loadingRender: false,
      DesState: "",
      Tarix: "",
      Rahgiri: "",
      TextVazeiat: " تراکنش با موفقیت انجام شد ",
      FixVariz: false,
      GatewayCode: null,
      Mablagh: 0,
      divToShow: 1,
      loading: false,
      DataAxios: {
        ArryfildValue: "",
        Method: "Post",
        Action: "NewtblAza",
        Token: this.$session.get("TokenNetPa"),
      },
      CodeMeli: "",
      CodeRahgiri: null,
      GatData: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      WwwtblTaahodatId: 0,
      currentIndex: 0,
      Ravesh: 0,
      IsUpload: false,
    };
  },
  computed: {
    CheckTabs() {
      return [
        { id: "nav-aut", title: "احراز هویت" },
        {
          id: "nav-pay",
          title:
            this.$session.get("CustCode") == 932
              ? "خرید سهام"
              : "پرداخت حق عضویت",
        },
        { id: "nav-state", title: "وضعیت درخواست" },
      ];
    },
    activeTabId() {
      const ids = ["nav-aut", "nav-pay", "nav-state"];
      return ids[this.currentIndex] || "nav-aut";
    },
  },
  methods: {
    onTabChange(id) {
      const map = { "nav-aut": 0, "nav-pay": 1, "nav-state": 2 };
      if (Object.prototype.hasOwnProperty.call(map, id)) {
        this.currentIndex = map[id];
      }
    },
    UploadFishVariz() {
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      };
      var formdata = new FormData();
      formdata.append("IdEftetah", this.CodeRahgiri);
      formdata.append("Image", this.fileinfo);
      formdata.append("wwwtblcomboidgrp328", 181070524);
      formdata.append("TableName", "wwwNewtblAzaForEftetahHesab");
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        this.IsUpload = true;
        this.ChangeCombo331();
      });
    },
    clickUploader() {
      document.getElementById("Uploader").click();
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = ["gif", "jpg", "jpeg", "png", "zip", "rar", "pdf"];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000
        );
        e.target.value = "";
        return;
      }
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل تصویر کارت ملی بیشتر از 5 مگابایت است ",
          "error",
          3000
        );
        return;
      } else {
        this.fileinfo = document.getElementById("Uploader").files[0];
        this.fileinfo1Isedit = true;
      }
    },
    GetRigister(rowid) {
      this.$router.push({ name: "Register", params: { RegisterCheck: rowid } });
    },
    GoToLogin() {
      this.$router.push("/");
    },
    ToPersian(number) {
      return Num2persian(number);
    },
    FixVarizGhest(val) {
      this.FixVariz = val;
    },
    Get_GatewayCode(val) {
      if (this.$session.get("CustCode") == 932) {
        this.GatewayCode = 932;
      } else {
        this.GatewayCode = val;
      }
    },
    Payment() {
      this.SendPayment();
    },
    SendPayment() {
      if (this.Mablagh < JSON.parse(this.$GetMablaghEftetahHesab())) {
        this.$mySweetDefault(
          "هشدار",
          "مبلغ وارد شده از حداقل مبلغ برای حق عضویت کمتر می باشد",
          "warning",
          3000
        );
        return;
      } else {
        var WwwtblAzaId = 0;
        var BnpCashDBtblTaahodatId = 0;
        var BnpCashDBtblAzaId = 0;

        var formdata = new FormData();
        formdata.append("id", this.CodeRahgiri);
        formdata.append("noeId", Number(JSON.parse(this.$GetNoeIdPishFarz())));
        var DataAxios_AzaForEftetahHesab = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "AzaForEftetahHesab",
          Token: "",
        };

        this.$PostFormData(DataAxios_AzaForEftetahHesab)
          .then((data) => {
            if (data.status == "OK") {
              this.WwwtblTaahodatId = data.wwwtblTaahodatId;
              WwwtblAzaId = data.wwwtblAzaId == undefined ? 0 : data.wwwtblAzaId;
              BnpCashDBtblTaahodatId =
                data.bnpCashDBtblTaahodatId == undefined
                  ? 0
                  : data.bnpCashDBtblTaahodatId;
              BnpCashDBtblAzaId =
                data.bnpCashDBtblAzaId == undefined ? 0 : data.bnpCashDBtblAzaId;
            } else if (data.status == "true") {
              this.WwwtblTaahodatId = data.wwwtblTaahodatId;
            }
          })
          .finally(() => {
            this.Mablagh = this.Mablagh;
            const WwwtblVarizGorohiRiz = [];
            WwwtblVarizGorohiRiz.push({
              WwwtblTaahodatId: this.WwwtblTaahodatId,
              Mablagh: Number(this.Mablagh),
              SharhRiz:
                "واریز حق عضویت جهت ثبت نام اولیه" +
                " _پرداخت کننده_ " +
                this.GatData.ozvName +
                " " +
                this.GatData.ozvFamily +
                this.GatData.codeMeli.trim(),
              WwwtblAzaId:
                this.WwwtblTaahodatId > 0
                  ? WwwtblAzaId
                  : Number(this.CodeRahgiri * -1),
              BnpCashDBtblTaahodatId:
                this.WwwtblTaahodatId > 0
                  ? BnpCashDBtblTaahodatId
                  : this.WwwtblTaahodatId,
              BnpCashDBtblAzaId:
                this.WwwtblTaahodatId > 0
                  ? BnpCashDBtblAzaId
                  : Number(this.CodeRahgiri * -1),
              MablaghJarime: 0,
              TarixGhest: this.$store.state.JalaliDate,
              IsTaahodatRiz: false,
            });

            this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh);
            this.DataAxios_Variz.ArryfildValue.CodeRahgiri =
              this.WwwtblTaahodatId > 0 ? Number(this.CodeRahgiri) : -1;
            this.DataAxios_Variz.ArryfildValue.Tarix =
              this.$store.state.JalaliDate;
            this.DataAxios_Variz.ArryfildValue.Sharh =
              "واریز حق عضویت جهت ثبت نام اولیه" +
              " _پرداخت کننده_ " +
              this.GatData.ozvName +
              " " +
              this.GatData.ozvFamily +
              this.GatData.codeMeli.trim();
            this.DataAxios_Variz.ArryfildValue.ZamanInsert =
              this.$store.state.JalaliDate;
            this.DataAxios_Variz.ArryfildValue.CustCode = Number(
              this.$session.get("CustCode")
            );
            this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
            this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
              this.WwwtblTaahodatId > 0
                ? WwwtblAzaId
                : Number(this.CodeRahgiri * -1);
            this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
            this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
              WwwtblVarizGorohiRiz;
            this.$PostData(this.DataAxios_Variz).then((result) => {
              if (result.status === "Success") {
                this.$Payment(
                  this.GatewayCode + "",
                  this.Mablagh + "",
                  this.GatData.ozvName + " " + this.GatData.ozvFamily,
                  "RegisterCheck",
                  this.GatData.mobile,
                  WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
                  1 + "",
                  "-1",
                  "واریز حق عضویت جهت ثبت نام اولیه",
                  this.WwwtblTaahodatId > 0
                    ? WwwtblAzaId + ""
                    : Number(this.CodeRahgiri * -1) + "",
                  this.$session.get("CustCode"),
                  this.GatData.wwwtblShobeId + "",
                  result.idRepoMaster,
                  this.GatData.codeMeli.trim()
                );
              } else {
                this.$mySweetDefaultTost(
                  " ",
                  " در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید",
                  "warning",
                  4000
                );
                this.DeleteAllItemsCart();
              }
            });
          });
      }
    },
    ChangeCombo331() {
      var formdata = new FormData();
      formdata.append("id", this.CodeRahgiri);
      var DataAxios_AzaForEftetahHesab = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "AzaForEftetahHesab/PayByUploadFish",
        Token: "",
      };

      this.$PostFormData(DataAxios_AzaForEftetahHesab).then((data) => {
        if (data == true) {
          this.getData();
          this.currentIndex = 2;
        }
      });
    },
    search() {
      this.openModal();
    },
    openModal() {
      $("#Modal-RegisterCheck").modal("show");
    },
    closeModal() {
      $("#Modal-RegisterCheck").modal("hide");
    },
    getData() {
      this.closeModal();
      if (this.CodeMeli != "") {
        this.loadingRender = true;
        this.loading = false;
        const formData = new FormData();
        formData.append("CodeMeli", this.CodeMeli);
        formData.append("CodeRahgiri", this.CodeRahgiri);
        this.DataAxios.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios).then((data) => {
          if (data != null) {
            this.Ravesh = 1;
            this.loading = true;
            this.GatData = data;
            this.Mablagh =
              Number(
                (this.appsettings && this.appsettings.MablaghEftetahHesab) ||
                  this.$GetMablaghEftetahHesab()
              ) || 0;
            this.Rahgiri = data.codeRahgiri;
            this.loadingRender = false;

            //#region برای صندوق مادر  مبالغ عضویت متفاوت میشود
            if (this.$session.get("CustCode") == "953") {
              // نوع مشتری ==> کسبه مادر
              if (data.wwwtblTafsiliTypeId == 11991) {
                this.Mablagh = 5000000;
              } else {
                this.Mablagh = 1000000;
              }
            }
            //#endregion

            this.closeModal();
          } else {
            this.loading = false;
            this.loadingRender = false;
            this.$mySweetDefault(
              "هشدار",
              "کد ملی وارد شده معتبر نیست ",
              "warning",
              3000
            );
          }
        });
      } else {
        this.loading = false;
        this.loadingRender = false;
        this.$mySweetDefault(
          "هشدار",
          "کد ملی وارد نشده است ",
          "warning",
          3000
        );
      }
    },
    nextPage(number) {
      this.selectCurent(document.getElementById("head" + number), number);
    },
    selectCurent(data, number) {
      var headers = document.getElementsByClassName("hoverHeader");
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index];
        element.classList.remove("current");
      }
      if (data.target) {
        data.target.parentNode.classList.add("current");
      } else {
        data.parentNode.classList.add("current");
      }
      this.divToShow = number;
    },
    Go() {
      if (this.currentIndex == 1 && this.IsUpload == false && this.Ravesh == 2) {
        this.$mySweetDefault(
          "عدم بارگذاری فیش",
          "لطفا فیش واریزی خودرا بارگذاری و آپلود نمایید",
          "warning",
          3000
        );
        return;
      }
      if (this.currentIndex < 2) {
        this.currentIndex++;
      }
    },
    getCustomerDate() {
      var axios = require("axios");
      var config = {
        method: "GET",
        url: "/appSettings.json?nocache=123",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Content-Type": "application/json",
        },
      };
      axios(config).then((result) => {
        if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
          window.location = window.location.href + "?eraseCache=true";
        } else {
          this.appsettings = result.data;
          this.gettblCustomer(this.appsettings.NetPaApi);
        }
      });
    },
    gettblCustomer(NetPaApi) {
      this.loadingRender = true;
      var settings = {
        method: "Post",
        url: NetPaApi + "Setting",
        headers: {},
        data: null,
      };
      var axios = require("axios");
      axios(settings)
        .then((result) => {
          this.CountLogin = result.data.countAuth;

          this.$PostData({
            ArryfildValue: {},
            Action: "GetTblCustomer",
            method: "GET",
            Token: "",
          })
            .then((data) => {
              let CustomerName = data.name;
              if (data.custCode == 561) {
                this.$store.state.NameSandogh = "صندوق قرض الحسنه";
                this.$session.set("NameSandogh", "صندوق قرض الحسنه");
                CustomerName = "صندوق قرض الحسنه";
              } else {
                this.$store.state.NameSandogh = data.name;
                this.$session.set("NameSandogh", data.name);
                let word = "تعاونی";
                if (CustomerName.indexOf(word) !== -1) {
                  this.$session.set("IsTaavoniEtebar", true);
                } else {
                  this.$session.set("IsTaavoniEtebar", false);
                }
              }
              this.$session.set("CustCode", data.custCode);
              document.title = " خدمات الکترونیکی " + data.name;
              this.loadingRender = false;
              this.loadingText = " ورود به سامانه";
            })
            .catch((e) => {
              this.gettblCustomer();
            })
            .finally(() => {
              this.loadingRender = false;
            });
        })
        .catch(() => {
          this.gettblCustomer();
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
  },
  mounted() {
    document.documentElement.classList.add("register-check-html");
    document.body.classList.add("register-check-html");
    this.getCustomerDate();
    if (this.$route.params.Status) {
      this.CodeRahgiri = this.$route.params.Status;
      if (this.CodeRahgiri == 0) {
        this.NotCode = true;
        this.CodeRahgiri = null;
      }
      this.openModal();
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove("register-check-html");
    document.body.classList.remove("register-check-html");
  },
};
</script>
<style scoped>
.register-check-page {
  min-height: 100%;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  background: #f5f7fb !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color 160ms ease,
    background 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease;
}

.sv-btn:focus {
  outline: none;
}

.sv-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.sv-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.sv-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

.sv-btn--ghost:not(:disabled):hover {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.16);
}

.sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

.register-check-search-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 0.35rem 0.85rem;
  color: #29345f;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

.register-check-search-btn:hover,
.register-check-search-btn:focus {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

@media (max-width: 767px) {
  .register-check-page {
    padding: 10px 12px 20px;
  }

  .sv-btn--wide {
    width: 100%;
  }
}
</style>
<style>
html.register-check-html,
body.register-check-html,
body.register-check-html #app,
#RegisterCheck.register-check-page,
#RegisterCheck {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
}

#RegisterCheck .register-check-card.netpa-card,
#RegisterCheck .register-check-card {
  height: auto !important;
  margin: 0 !important;
  background: #fff !important;
}

#RegisterCheck .register-check-card .netpa-card__body {
  padding: 1.15rem 1.25rem 1.35rem !important;
  background: #fff !important;
}

#RegisterCheck .register-check-tab-content {
  min-height: 12rem;
}

#RegisterCheck .register-check-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin: 0 0 14px;
}

#RegisterCheck .register-check-label {
  display: block;
  margin-bottom: 8px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

#RegisterCheck .register-check-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  text-align: center;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #f9fbfc;
  box-shadow: none;
}

#RegisterCheck .register-check-input:focus {
  outline: none;
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

#RegisterCheck .register-check-amount-words {
  margin-top: 8px;
  color: #b44f46;
  font-size: 13px;
  font-weight: 700;
}

#RegisterCheck .register-check-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 2rem 1rem;
  color: #6b7b8e;
  text-align: center;
}

#RegisterCheck .register-check-empty i {
  color: #287db4;
  font-size: 28px;
}

#RegisterCheck .register-check-empty p {
  margin: 0;
  font-size: 13px;
  line-height: 1.8;
}

#RegisterCheck .register-check-status-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 1rem 1.05rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #f8fafc;
}

#RegisterCheck .register-check-status-card__icon {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  color: #287db4;
  font-size: 18px;
  place-items: center;
  border-radius: 12px;
  background: #edf5fb;
}

#RegisterCheck .register-check-status-card__body {
  min-width: 0;
  flex: 1 1 auto;
}

#RegisterCheck .register-check-status-card__body h6 {
  margin: 0 0 0.35rem;
  color: #29345f;
  font-size: 14px !important;
  font-weight: 800;
  line-height: 1.7;
}

#RegisterCheck .register-check-status-card__body p {
  margin: 0 0 0.75rem;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.8;
}

#RegisterCheck .register-check-status-card--success {
  border-color: rgba(5, 184, 200, 0.22);
  background: #e9f9fb;
}

#RegisterCheck .register-check-status-card--success .register-check-status-card__icon {
  color: #068997;
  background: #fff;
}

#RegisterCheck .register-check-status-card--info {
  border-color: #d4e6f3;
  background: #edf5fb;
}

#RegisterCheck .register-check-status-card--warning {
  border-color: #eed9b0;
  background: #fdf8ef;
}

#RegisterCheck .register-check-status-card--warning .register-check-status-card__icon {
  color: #c48726;
  background: #fff7e8;
}

#RegisterCheck .register-check-status-card--danger {
  border-color: #f0d4d1;
  background: #fcefed;
}

#RegisterCheck .register-check-status-card--danger .register-check-status-card__icon {
  color: #b44f46;
  background: #fff;
}

#RegisterCheck .register-check-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 12px;
  color: #7a5410;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.7;
  border: 1px solid #eed9b0;
  border-radius: 12px;
  background: #fdf8ef;
}

#RegisterCheck .register-check-note i {
  margin-top: 2px;
  color: #c7922c;
}

#RegisterCheck .register-check-methods {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}

#RegisterCheck .register-check-method {
  min-height: 44px;
  padding: 8px 12px;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

#RegisterCheck .register-check-method.is-active {
  color: #068997;
  border-color: rgba(5, 184, 200, 0.35);
  background: #e9f9fb;
}

#RegisterCheck .register-check-pay-panel {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
}

#RegisterCheck .register-check-pay-step {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1rem 1.05rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
}

#RegisterCheck .register-check-pay-step__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px;
  color: #29345f;
  font-size: 14px !important;
  font-weight: 800;
}

#RegisterCheck .register-check-pay-step__num {
  display: inline-grid;
  width: 24px;
  height: 24px;
  color: #287db4;
  font-size: 12px;
  place-items: center;
  border-radius: 8px;
  background: #edf5fb;
}

#RegisterCheck .register-check-pay-step .register-check-field {
  margin-bottom: 0;
}

#RegisterCheck .register-check-amount-hint {
  margin-top: 8px;
  color: #6b7b8e;
  font-size: 12px;
}

#RegisterCheck .register-check-gateway .border-bottom {
  display: none;
}

#RegisterCheck .register-check-gateway img {
  width: 64px;
  height: 64px;
  margin: 0 0 0 8px;
  padding: 6px;
  object-fit: contain;
  border: 1px solid #dbe5eb !important;
  border-radius: 14px !important;
  background: #fff;
}

#RegisterCheck .register-check-gateway img.SelectedImageIcon {
  border: 2px solid #05b8c8 !important;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.15);
}

#RegisterCheck .register-check-gateway .text-dark {
  color: #6b7b8e !important;
  font-size: 12px;
}

#RegisterCheck .register-check-gateway .mt-3 {
  margin-top: 10px !important;
}

#RegisterCheck .register-check-pay-btn {
  width: 100%;
  min-height: 46px;
  margin-top: 4px;
}

#RegisterCheck .register-check-gateway .alert-warning {
  margin-top: 12px !important;
  padding: 10px 12px;
  font-size: 12px;
  border: 1px solid #eed9b0;
  border-radius: 12px;
  background: #fdf8ef;
}

#RegisterCheck .register-check-receipt {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 1rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
}

#RegisterCheck .register-check-receipt__badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  color: #068997;
  font-size: 14px;
  font-weight: 800;
  border-radius: 12px;
  background: #e9f9fb;
}

#RegisterCheck .register-check-receipt__rows {
  display: grid;
  gap: 8px;
}

#RegisterCheck .register-check-receipt__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  color: #6b7b8e;
  font-size: 13px;
  border-bottom: 1px solid #e8eef2;
}

#RegisterCheck .register-check-receipt__row:last-child {
  border-bottom: 0;
}

#RegisterCheck .register-check-receipt__row strong {
  color: #13243a;
  font-weight: 700;
  text-align: left;
}

#RegisterCheck .register-check-upload {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

#RegisterCheck .register-check-upload__lead {
  margin: 0;
  color: #31465f;
  font-size: 13px;
  line-height: 1.8;
}

#RegisterCheck .register-check-upload__lead b {
  color: #b44f46;
}

#RegisterCheck .register-check-upload__drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 1.15rem 1rem;
  color: #29345f;
  text-align: center;
  border: 1px dashed #bdcbd4;
  border-radius: 16px;
  background: #f8fafc;
  cursor: pointer;
}

#RegisterCheck .register-check-upload__drop i {
  color: #287db4;
  font-size: 22px;
}

#RegisterCheck .register-check-upload__drop strong {
  font-size: 13px;
}

#RegisterCheck .register-check-upload__drop span {
  color: #6b7b8e;
  font-size: 12px;
}

#RegisterCheck .register-check-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eef2;
}

#RegisterCheck .register-check-modal .modal-content {
  direction: rtl;
  text-align: right;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 20px;
  box-shadow: 0 18px 48px rgba(15, 39, 68, 0.12);
}

#RegisterCheck .register-check-modal__header {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  color: #29345f;
  border-bottom: 1px solid #e8eef2;
  background:
    radial-gradient(circle at 100% 0%, rgba(5, 184, 200, 0.1), transparent 42%),
    linear-gradient(100deg, rgba(237, 247, 251, 0.96), #fff 62%);
}

#RegisterCheck .register-check-modal__header .modal-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #29345f;
  font-size: 15px;
  font-weight: 800;
}

#RegisterCheck .register-check-modal__header .modal-title i {
  color: #287db4;
}

#RegisterCheck .register-check-modal__body {
  padding: 1.15rem 1.15rem 1.25rem;
}

#RegisterCheck .register-check-search-actions {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 10px;
  margin-top: 6px;
}

#RegisterCheck .register-check-search-actions .sv-btn {
  width: 100%;
  min-height: 44px;
}

#RegisterCheck .register-check-modal__footer {
  display: flex;
  justify-content: flex-start;
  padding: 12px 18px 16px;
  border-top: 1px solid #e8eef2;
}

@media (max-width: 767px) {
  #RegisterCheck .register-check-card .netpa-card__body {
    padding: 0.9rem 0.85rem 1.1rem !important;
  }

  #RegisterCheck .register-check-pay-panel,
  #RegisterCheck .register-check-methods {
    grid-template-columns: 1fr;
  }

  #RegisterCheck .register-check-footer,
  #RegisterCheck .register-check-status-card {
    flex-direction: column;
  }

  #RegisterCheck .register-check-footer .sv-btn--wide {
    width: 100%;
  }
}
</style>
